export const LINKS_LIST = 'LINKS_LIST';

export const UPDATE_LINK = 'UPDATE_LINK';

export const ADD_LINK = 'ADD_LINK';

export const MOVE_LINK = 'MOVE_LINK';

export const MOVE_LINK_ERROR = 'MOVE_LINK_ERROR';

export const REMOVE_LINK = 'REMOVE_LINK';



// WEBPACK FOOTER //
// ./src/store/modules/links/types.js